// Clipboard.ts

import type { DotNet } from '@microsoft/dotnet-js-interop'

export class Clipboard {
	private readonly MIME_HTML = 'text/html'
	private readonly MIME_PLAIN = 'text/plain'

	private dotNetObjRef?: DotNet.DotNetObject

	setReference(dotNetObjRef: DotNet.DotNetObject): void {
		this.dotNetObjRef = dotNetObjRef
	}

	async copyHtmlTable(html: string, plainTextFallback: string): Promise<void> {
		try {
			const item = new ClipboardItem({
				[this.MIME_HTML]: new Blob([html], { type: this.MIME_HTML }),
				[this.MIME_PLAIN]: new Blob([plainTextFallback], { type: this.MIME_PLAIN }),
			})

			await navigator.clipboard.write([item])
			await this._invokeHtmlBlazor(true)
		}
		catch {
			await this._invokeHtmlBlazor(false)
		}
	}

	async copyMarkdownTable(markdown: string): Promise<void> {
		try {
			await navigator.clipboard.writeText(markdown)
			await this._invokeMarkdownBlazor(true)
		}
		catch {
			await this._invokeMarkdownBlazor(false)
		}
	}

	private async _invokeHtmlBlazor(success: boolean): Promise<void> {
		await this.dotNetObjRef?.invokeMethodAsync('OnHtmlCopied', success)
	}

	private async _invokeMarkdownBlazor(success: boolean): Promise<void> {
		await this.dotNetObjRef?.invokeMethodAsync('OnMarkdownCopied', success)
	}
}
